import { axios } from '@/di-container/axios';
import { HttpClient } from '@remodeling/base';
import { GetAgentDetailGateway, GetAgentDetailRequest } from '@remodeling/shop';

export const expertGateway = () => {
  return {
    getExpertDetail: new ClientGetExpertDetailGateway(axios),
  };
};

class ClientGetExpertDetailGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetAgentDetailRequest) {
    const apiResponse = await new GetAgentDetailGateway(this.httpClient).exec(
      req,
    );

    return apiResponse;
  }
}
